module.exports = __webpack_public_path__ + "img/mc-symbol.200bfe4f.svg";